import { render, staticRenderFns } from "./ProductDescribingForm.vue?vue&type=template&id=fae01bd0&scoped=true"
import script from "./ProductDescribingForm.vue?vue&type=script&lang=js"
export * from "./ProductDescribingForm.vue?vue&type=script&lang=js"
import style0 from "./ProductDescribingForm.vue?vue&type=style&index=0&id=fae01bd0&prod&lang=scss&scoped=true"
import style1 from "./ProductDescribingForm.vue?vue&type=style&index=1&id=fae01bd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae01bd0",
  null
  
)

export default component.exports